(function(){
  const MAX_SPARKLES = 40;
  const SPAWN_INTERVAL = 45;
  const LIFETIME = 700;
  let activeCount = 0;
  let lastSpawn = 0;

  function spawnSparkle(x, y, opts = {}) {
    if (activeCount >= MAX_SPARKLES) return;
    const el = document.createElement('div');
    el.className = 'sparkle-dot';
    const size = opts.size || (2 + Math.random() * 3);
    const driftX = opts.driftX ?? (Math.random() - 0.5) * 30;
    const driftY = opts.driftY ?? (Math.random() - 0.5) * 30;
    const duration = opts.duration || LIFETIME;
    el.style.width = size + 'px';
    el.style.height = size + 'px';
    el.style.transform = `translate(${x}px, ${y}px) scale(1)`;
    document.body.appendChild(el);
    activeCount++;
    const anim = el.animate([
      { transform: `translate(${x}px, ${y}px) scale(1)`, opacity: 1 },
      { transform: `translate(${x + driftX}px, ${y + driftY}px) scale(0.2)`, opacity: 0 }
    ], { duration, easing: 'ease-out' });
    anim.onfinish = () => { el.remove(); activeCount--; };
  }

  document.addEventListener('mousemove', (e) => {
    const now = performance.now();
    if (now - lastSpawn < SPAWN_INTERVAL) return;
    lastSpawn = now;
    spawnSparkle(e.clientX, e.clientY);
  });

  document.addEventListener('click', (e) => {
    const burstCount = 6 + Math.floor(Math.random() * 3);
    for (let i = 0; i < burstCount; i++) {
      const angle = (Math.PI * 2 * i) / burstCount + Math.random() * 0.4;
      const distance = 20 + Math.random() * 25;
      spawnSparkle(e.clientX, e.clientY, {
        driftX: Math.cos(angle) * distance,
        driftY: Math.sin(angle) * distance,
        size: 3 + Math.random() * 3,
        duration: 500 + Math.random() * 300
      });
    }
  });
})();